function timeAgo(dateStr) {
  const diff = Date.now() - new Date(dateStr).getTime()
  const mins = Math.floor(diff / 60000)
  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins}m ago`
  const hrs = Math.floor(mins / 60)
  if (hrs < 24) return `${hrs}h ago`
  return `${Math.floor(hrs / 24)}d ago`
}

export function InboxNotificationRow({ notification, isSelected, onClick, isDarkMode }) {
  const isUnread = !notification.is_read

  return (
    <button
      onClick={onClick}
      className={`w-full text-left flex items-start gap-3 px-4 py-3 border-b transition-colors ${
        isSelected
          ? isDarkMode ? 'bg-slate-700' : 'bg-orange-50'
          : isDarkMode ? 'hover:bg-slate-700/50' : 'hover:bg-gray-50'
      } ${isDarkMode ? 'border-slate-700' : 'border-gray-100'}`}
    >
      <div className={`w-8 h-8 rounded-full flex-shrink-0 flex items-center justify-center text-xs font-bold ${
        isDarkMode ? 'bg-slate-600 text-slate-300' : 'bg-orange-100 text-sfp-orange'
      }`}>
        {(notification.title ?? 'N').charAt(0).toUpperCase()}
      </div>
      <div className="flex-1 min-w-0">
        <p className={`text-sm truncate ${isUnread ? 'font-semibold' : 'font-normal'} ${
          isDarkMode ? 'text-slate-200' : 'text-sfp-darkgray'
        }`}>
          {notification.title ?? 'Notification'}
        </p>
        {notification.message && (
          <p className={`text-xs truncate mt-0.5 ${isDarkMode ? 'text-slate-400' : 'text-gray-500'}`}>
            {notification.message}
          </p>
        )}
        <p className={`text-xs mt-1 ${isDarkMode ? 'text-slate-500' : 'text-gray-400'}`}>
          {timeAgo(notification.created_at)}
        </p>
      </div>
      {isUnread && (
        <span className="w-2 h-2 rounded-full bg-sfp-orange mt-2 flex-shrink-0" />
      )}
    </button>
  )
}
